{
    "Accessibility menu": "Accessibility menu",
    "Close": "Zoumaachen",
    "Content adjustments": "Inhalt Unpassungen",
    "Navigation adjustments": "Navigatioun Unpassungen",
    "Text Align": "Text Align",
    "Align Left": "Lénks ausriichten",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Schrëftgréisst unpassen",
    "Highlight Title": "Titel markéieren",
    "Highlight Links": "Links markéieren",
    "Readable Font": "Liesbar Schrëft",
    "Colour adjustments": "Faarfleg Unpassungen",
    "Dark Contrast": "Däischteren Kontrast",
    "Light Contrast": "Hellen Kontrast",
    "High Contrast": "Héijen Kontrast",
    "High Saturation": "Héij Sättigung",
    "Low Saturation": "Niddrég Sättigung",
    "Monochrome": "Monochrom",
    "Tools": "Tools",
    "Reading Guide": "Guide fir ze liesen",
    "Big Cursor": "Groussen Cursor",
    "Increase Font Size": "Schrëftgréisst erhéijen",
    "Decrease Font Size": "Schrëftgréisst ernidderegen",
    "Letter Spacing": "Zeechenofstand",
    "Line Height": "Linn Héicht",
    "Font Weight": "Schrëftgewiicht",
    "Dyslexia Font": "Schrëft fir Dyslexie",
    "Language": "Sprooch",
    "Accessibility widget": "Accessibility menu opmaachen",
    "Accessibility Profiles": "Accessibility Profiler",
    "Cognitive Disability": "Kognitiv Behënnerung",
    "Seizure Safe": "Sécher fir Epilepsie",
    "Accessibility statement": "Accessibility Erklärung",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Animatiounen stoppen",
    "Reset all settings": "Astellungen zrécksetzen",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
